module.exports = __webpack_public_path__ + "img/xignature-logo-alt.52034976.png";